import { render } from "./IngestPreview.vue?vue&type=template&id=6845f586&scoped=true"
import script from "./IngestPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./IngestPreview.vue?vue&type=script&setup=true&lang=js"

import "./IngestPreview.vue?vue&type=style&index=0&id=6845f586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6845f586"],['__file',"src/components/ui/StreamSidebar/IngestPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6845f586"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6845f586', __exports__)) {
    api.reload('6845f586', __exports__)
  }
  
  module.hot.accept("./IngestPreview.vue?vue&type=template&id=6845f586&scoped=true", () => {
    api.rerender('6845f586', render)
  })

}


export default __exports__